import {Component, ViewChild} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {MerchantBulkCreateService} from "OpsCenter/ops-support/merchant-bulk-create/merchant-bulk-create.service";

@Component({
  selector: 'app-merchant-bulk-create',
  template: require('./merchant-bulk-create.component.html'),
  styles: [require('./merchant-bulk-create.component.less')],
})
export class MerchantBulkCreateComponent {
  fileToUpload: File = null;
  private isLoading = false;

  @ViewChild('fileInput', {static: false})
  private fileInput: HTMLInputElement;

  constructor(private merchantBulkCreateService: MerchantBulkCreateService, private notificationService: ToastrService) {
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  upload() {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.merchantBulkCreateService.create(this.fileToUpload)
      .subscribe(() => this.handleUploadSuccess(), res => this.handleUploadError(res));
  }
  private handleUploadSuccess() {
    this.notificationService.success(`The file will be processed and you will receive an email with the result of the operation`);
    this.clearForm();
    this.disableLoading();
  }

  private handleUploadError(res) {
    this.notificationService.error(`There were errors on the import operation. Please review and fix them before trying again`);
    this.disableLoading();
  }

  private clearForm() {
    this.fileToUpload = null;
    this.fileInput.value = '';
  }
  private enableLoading() {
    this.isLoading = true;
  }

  private disableLoading() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.component.ts